import isArray from 'lodash/isArray';

export class ApiService {
	constructor(API_ENDPOINT, $cookies, $http) {
		'ngInject';

		this.$http = $http;
        this.$http.defaults.cache = false;
		this.$cookies = $cookies;
		this.API_ENDPOINT = API_ENDPOINT;
		this.setDefaultHeaders();
	}
	
	setDefaultHeaders(headerVal) {
		this.$http.defaults.headers.common['Authorization'] = headerVal;
	}
	
	removeDefaultHeaders() {
		this.$http.defaults.headers.common['Authorization'] = undefined;
	}
	
	getResourceUrl(path) {
		return this.API_ENDPOINT + path;
	}
	
	getImageUrl(path) {
		return this.API_ENDPOINT + 'uploaded-images/' + path;
	}
	
	getErrorMessage(details) {
		if(details.status === 500) {
			return "Something went wrong";
		}
		else {
		   if(isArray(details.data.message)) {
		   		return details.data.message[0];
		   }
		   else {
   				return details.data.message
		   }	
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/common/libs/api/api.service.js